import useLoggedInUser from '@/composables/logged-in-user/logged-in-user';
import useRepo from '@/nebula/repo';
import { aiChatSkill as aiChatSkillConfig } from 'shared/api/query/configs.json';
import { builtinSkills, ownSkills, suggestedSkills } from '@/lib/ai-chat-skills';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const builtinsByLocale = new Map();
const builtinsFor = (locale, t) => {
  if (!builtinsByLocale.has(locale)) {
    builtinsByLocale.set(locale, builtinSkills(t));
  }
  return builtinsByLocale.get(locale);
};

export default function useAiChatSkills() {
  const { t, locale } = useI18n();
  const repo = useRepo(aiChatSkillConfig.model);
  const { loggedInUser } = useLoggedInUser();

  const own = computed(() => ownSkills(repo.entityList.value));

  const builtins = computed(() => builtinsFor(locale.value, t));

  const suggestions = computed(() => suggestedSkills({ own: own.value, builtins: builtins.value }));

  const createSkill = ({ title, body }) => repo.createSingle({
    title,
    body,
    creator: { uid: loggedInUser.value.uid },
  });

  const updateSkill = ({ uid, title, body }) => repo.updateSingle({ uid, title, body });

  const deleteSkill = (skill) => repo.deleteSingle(skill.uid);

  return {
    own,
    builtins,
    suggestions,
    createSkill,
    updateSkill,
    deleteSkill,
  };
}
